import React from "react";
import { Container } from "react-bootstrap";
import InnerBanner from "../../Components/InnerBanner";
import { Loader } from "../../Components/Loader";
import { ANTI_BRIBERY } from "../../services/Url";
import { useCustomGet } from "../../services/Service";

export const AntiBribery = () => {
  const { data, isLoading } = useCustomGet(ANTI_BRIBERY)

  var bannerContent = {
    cardTitle: data?.anti_bribery_banner_heading,
    cardPara: "",
  }

  return (
    <>
     {
        isLoading ? 
        <Loader /> :''
      }
      <InnerBanner bannerCnt={bannerContent} banImg={data?.anti_bribery_banner_image} />
      <div className="internal-service-page" id="cyber-essen-certi-service">
        <Container>
        <div className="privacy custom-list sec-padding"
            dangerouslySetInnerHTML={{__html: data?.anti_bribery_content}}
        >
        </div>
        </Container>
      </div>
    </>
  );
};
